/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontApplicationSuccessModel
 */
export interface FrontApplicationSuccessModel {
    /**
     * OK
     * @type {boolean}
     * @memberof FrontApplicationSuccessModel
     */
    success: boolean;
}

/**
 * Check if a given object implements the FrontApplicationSuccessModel interface.
 */
export function instanceOfFrontApplicationSuccessModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;

    return isInstance;
}

export function FrontApplicationSuccessModelFromJSON(json: any): FrontApplicationSuccessModel {
    return FrontApplicationSuccessModelFromJSONTyped(json, false);
}

export function FrontApplicationSuccessModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationSuccessModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function FrontApplicationSuccessModelToJSON(value?: FrontApplicationSuccessModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

